import { Action } from '../../../types/actions';

export const SET_CARD_SHOW_REPLIES = 'SET_CARD_SHOW_REPLIES';
export function setCardShowReplies(id: number, value: boolean): Action {
	return { type: SET_CARD_SHOW_REPLIES, payload: { id, value } };
}

export const SET_CARD_REPLY_TEXT = 'SET_CARD_REPLY_TEXT';
export function setCardReplyText(id: number, value: string): Action {
	return { type: SET_CARD_REPLY_TEXT, payload: { id, value } };
}
